<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
        ref="table" class="custom-tbl" style="width: 100%;" height="100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="UsingTypeStr" label="应用类型" width="140"></el-table-column>
        <el-table-column prop="GradeName" label="校区" width="120"></el-table-column>
        <el-table-column prop="DepartmentName" label="部门"></el-table-column>
        <el-table-column prop="Sort" label="序号" width="70"></el-table-column>
        <el-table-column prop="CreateTime" label="添加时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div class="table-op-stacked">
              <el-button @click="showAddApprovalNode(scope.row)" type="text" style="margin: 0 !important;">
                审批人员设置
              </el-button>
              <el-button @click="showCopyToUsers(scope.row)" type="text" style="margin: 0 !important;">
                抄送人员设置
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="10" :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!--编辑-->
      <el-dialog title="编辑调代课审批流程" :visible.sync="editFormVisible" :close-on-click-modal="false" destroy-on-close>
        <el-form :model="editForm" label-width="90px" :rules="formRules" ref="editForm">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="editForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="应用类型" prop="UsingType">
            <el-select v-model="editForm.UsingType" :disabled="true" style="width: 100%;">
              <el-option v-for="item in usingTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区" prop="GradeId">
            <el-select v-model="editForm.GradeId" placeholder="请选择校区" style="width: 100%;">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="editForm.Sort" :min="1" style="width: 120px;"></el-input-number>
            <span style="margin-left: 8px; color: #909399; font-size: 12px;">同校区多条流程时取序号最小的执行</span>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editFormVisible = false">取消</el-button>
          <el-button type="primary" :loading="editLoading" @click="editSubmit">提交</el-button>
        </div>
      </el-dialog>

      <!--新增-->
      <el-dialog title="新增调代课审批流程" :visible.sync="addFormVisible" :close-on-click-modal="false" destroy-on-close>
        <el-form :model="addForm" label-width="90px" :rules="formRules" ref="addForm">
          <el-form-item label="名称" prop="Name">
            <el-input v-model="addForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="应用类型" prop="UsingType">
            <el-select v-model="addForm.UsingType" placeholder="请选择应用类型" style="width: 100%;">
              <el-option v-for="item in usingTypeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="校区" prop="GradeId">
            <el-select v-model="addForm.GradeId" placeholder="请选择校区" style="width: 100%;">
              <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="序号" prop="Sort">
            <el-input-number v-model="addForm.Sort" :min="1" style="width: 120px;"></el-input-number>
            <span style="margin-left: 8px; color: #909399; font-size: 12px;">同校区多条流程时取序号最小的执行</span>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addFormVisible = false">取消</el-button>
          <el-button type="primary" :loading="addLoading" @click="addSubmit">提交</el-button>
        </div>
      </el-dialog>

      <!--审批节点-->
      <el-dialog title="审批人员设置" width="65%" :visible.sync="addApprovalNodeVisible"
        :close-on-click-modal="false" center destroy-on-close>
        <el-table :data="approvalNodes" style="width: 100%;">
          <el-table-column prop="index" label="序号" width="80" header-align="center" align="center"></el-table-column>
          <el-table-column label="节点信息" header-align="center">
            <template slot-scope="scope">
              <el-form :inline="true" :model="scope.row" :rules="approvalFormRules"
                :ref="`approvalForm${scope.$index}`">
                <el-form-item prop="role">
                  <el-select v-model="scope.row.role" style="width: 180px;" placeholder="请选择角色"
                    @change="roleChange(scope.$index)">
                    <el-option v-for="item in roleOptions" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="scope.row.role === 'specificPerson'" prop="specificUsers">
                  <el-select v-model="scope.row.specificUsers" multiple filterable
                    placeholder="请选择或输入审批人员" @change="specificUsersChange(scope.$index)">
                    <el-option v-for="user in userList" :key="user.Id" :label="user.TeacherName"
                      :value="user.Id"></el-option>
                  </el-select>
                  <div style="margin-top: 4px; color: #909399; font-size: 12px;">
                    审批人需先录入课表管理员
                  </div>
                </el-form-item>
                <el-form-item prop="nodeName">
                  <el-input v-model="scope.row.nodeName" placeholder="节点名称" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="removeNode(scope.$index)">删除</el-button>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button type="primary" @click="addNode">添加节点</el-button>
          <el-button type="primary" @click="submitApprovalNodes">保存</el-button>
          <el-button @click="addApprovalNodeVisible = false">取消</el-button>
        </div>
      </el-dialog>

      <!--抄送-->
      <el-dialog title="调代课通过抄送人员设置" width="50%" :visible.sync="copyToUsersVisible"
        :close-on-click-modal="false" center destroy-on-close>
        <!-- label-width 与同页其它表单一致，避免未设宽度时浮动 label 与多选 tag 重叠。最后修改：2026-09-20 -->
        <el-form :model="copyToForm" ref="copyToForm" label-width="90px">
          <el-form-item label="抄送人员" prop="copyToUsers">
            <el-select v-model="copyToForm.copyToUsers" multiple filterable placeholder="请选择或输入人员"
              style="width: 100%;">
              <el-option v-for="user in userList" :key="user.Id" :label="user.TeacherName"
                :value="user.Id"></el-option>
            </el-select>
            <div style="margin-top: 10px; color: #606266; font-size: 12px;">
              调代课申请通过后，系统将自动通知以上选择的抄送人员
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="copyToUsersVisible = false">取消</el-button>
          <el-button type="primary" :loading="copyToLoading" @click="saveCopyToUsers">保存</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import { testapi } from '../../api/modules/auth';
import { getLeaveApprovalProcessListPage, removeLeaveApprovalProcess, editLeaveApprovalProcess, addLeaveApprovalProcess, getProcessOfficer, addProcessOfficer, getProcessCc, saveProcessCc, getCampusList, getScheduleAdminsForApproval } from '../../api/modules/misc';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';

const USING_TYPE_LABELS = {
  course_adjustment: '调代课',
  special_course_adjustment: '特殊课程调代课'
};

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {},
      searchList: [{ label: '名称', key: 'name' }],
      usingTypeOptions: [
        { value: 'course_adjustment', label: '调代课' },
        { value: 'special_course_adjustment', label: '特殊课程调代课' }
      ],
      roleOptions: [{ label: '指定人员', value: 'specificPerson' }],
      users: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      DepartmentId: 0,
      campusOptions: [],

      editFormVisible: false,
      editLoading: false,
      editForm: {
        Id: 0,
        Name: '',
        UsingType: 'course_adjustment',
        LeaveTypeId: 0,
        GradeId: '',
        Sort: 1,
        DepartmentId: 0
      },

      addFormVisible: false,
      addLoading: false,
      addForm: {
        Name: '',
        UsingType: 'course_adjustment',
        LeaveTypeId: 0,
        GradeId: '',
        Sort: 1,
        DepartmentId: 0
      },

      formRules: {
        Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        UsingType: [{ required: true, message: '请选择应用类型', trigger: 'change' }],
        GradeId: [{ required: true, message: '请选择校区', trigger: 'change' }]
      },

      processId: '',
      addApprovalNodeVisible: false,
      approvalNodes: [],
      approvalFormRules: {
        nodeName: [{ required: true, message: '请输入节点名称', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }]
      },
      userList: [],

      copyToUsersVisible: false,
      copyToLoading: false,
      copyToForm: { copyToUsers: [] },
      currentProcessId: '',
      currentCampusId: ''
    };
  },

  methods: {
    handleQuery() {
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        usingTypes: 'course_adjustment,special_course_adjustment',
        ...this.filters
      };
      this.listLoading = true;
      testapi();
      getLeaveApprovalProcessListPage(para).then(res => {
        this.total = res.data.response.dataCount;
        const list = res.data.response.data || [];
        list.forEach(item => {
          item.UsingTypeStr = USING_TYPE_LABELS[item.UsingType] || item.UsingType;
        });
        this.users = list;
        this.listLoading = false;
      }).catch(() => { this.listLoading = false; });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    treeNodeClick(data) {
      this.DepartmentId = data.value;
      this.loadCampusOptions(data.value);
      this.handleQuery();
    },

    loadCampusOptions(departmentId) {
      if (!departmentId) {
        this.campusOptions = [];
        return;
      }
      getCampusList({ page: 1, intPageSize: 999, departmentId }).then(res => {
        if (res.data && res.data.success && res.data.response) {
          this.campusOptions = res.data.response.data || [];
        } else {
          this.campusOptions = [];
        }
      });
    },

    loadScheduleAdmins(departmentId, campusId) {
      const para = { departmentId };
      if (campusId) para.campusId = campusId;
      return getScheduleAdminsForApproval(para).then(res => {
        const list = (res.data && res.data.response) ? res.data.response : [];
        this.userList = list.map(u => ({ ...u, Id: String(u.Id) }));
      });
    },

    parseSpecificUserIds(raw) {
      if (!raw) return [];
      return String(raw).split(/[|/,，、]/).map(s => s.trim()).filter(Boolean);
    },

    /** 已保存的审批人不在下拉列表时补入选项，避免显示纯数字 ID */
    ensureUserOptions(ids, nodeName) {
      const existIds = new Set(this.userList.map(u => String(u.Id)));
      const names = (nodeName || '').replace(/审批$/, '').split(/[、,，/|]/).map(s => s.trim()).filter(Boolean);
      ids.forEach((id, idx) => {
        const sid = String(id);
        if (!existIds.has(sid)) {
          this.userList.push({
            Id: sid,
            TeacherName: names[idx] || names[0] || `教职工(${sid})`
          });
          existIds.add(sid);
        }
      });
    },

    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search;
      } else {
        this.filters = { key: item.search };
      }
      if (item.Func && typeof this[item.Func] === 'function') {
        this[item.Func].apply(this, item);
      }
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectCurrentRow(row);
    },

    selectCurrentRow(val) {
      if (!val) return;
      this.currentRow = val;
      this.$refs.table.clearSelection();
      this.$nextTick(() => {
        this.$refs.table.toggleRowSelection(val, true);
      });
    },

    handleAdd() {
      if (!this.DepartmentId) {
        this.$message.warning('请先选择左侧所属机构');
        return;
      }
      this.addForm = {
        Name: '',
        UsingType: 'course_adjustment',
        LeaveTypeId: 0,
        GradeId: '',
        Sort: 1,
        DepartmentId: this.DepartmentId
      };
      this.loadCampusOptions(this.DepartmentId);
      this.addFormVisible = true;
    },

    addSubmit() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return;
        this.addLoading = true;
        addLeaveApprovalProcess({ ...this.addForm }).then(res => {
          this.addLoading = false;
          if (res.data.success) {
            this.$message.success('新增成功');
            this.addFormVisible = false;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '新增失败');
          }
        }).catch(() => { this.addLoading = false; });
      });
    },

    handleEdit() {
      if (!this.currentRow) {
        this.$message.warning('请先选择要编辑的记录');
        return;
      }
      const row = this.currentRow;
      this.editForm = {
        Id: row.Id,
        Name: row.Name,
        UsingType: row.UsingType,
        LeaveTypeId: 0,
        GradeId: row.GradeId || '',
        Sort: row.Sort || 1,
        DepartmentId: row.DepartmentId || 0
      };
      this.loadCampusOptions(row.DepartmentId);
      this.editFormVisible = true;
    },

    editSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.editLoading = true;
        editLeaveApprovalProcess({ ...this.editForm }).then(res => {
          this.editLoading = false;
          if (res.data.success) {
            this.$message.success('修改成功');
            this.editFormVisible = false;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '修改失败');
          }
        }).catch(() => { this.editLoading = false; });
      });
    },

    handleDel() {
      if (!this.currentRow) {
        this.$message.warning('请先选择要删除的记录');
        return;
      }
      this.$confirm('确认删除该审批流程？', '提示', { type: 'warning' }).then(() => {
        removeLeaveApprovalProcess({ id: this.currentRow.Id }).then(res => {
          if (res.data.success) {
            this.$message.success('删除成功');
            this.currentRow = null;
            this.handleQuery();
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        });
      }).catch(() => {});
    },

    async showAddApprovalNode(row) {
      this.processId = row.Id;
      this.currentCampusId = row.GradeId || '';
      this.approvalNodes = [];
      this.addApprovalNodeVisible = true;
      try {
        await this.loadScheduleAdmins(row.DepartmentId, row.GradeId);
        const res = await getProcessOfficer({ processId: row.Id });
        const nodes = (res.data && res.data.response) ? res.data.response : [];
        this.approvalNodes = nodes.map((n, i) => {
          const specificUsers = this.parseSpecificUserIds(n.SpecificPerson || n.specificPerson);
          this.ensureUserOptions(specificUsers, n.NodeName || n.nodeName);
          return {
            index: n.Index || n.index || (i + 1),
            nodeName: n.NodeName || n.nodeName || '',
            role: n.Role || n.role || 'specificPerson',
            specificUsers: specificUsers.map(id => String(id))
          };
        });
        if (this.approvalNodes.length === 0) this.addNode();
      } catch (e) {
        this.$message.error('加载审批人员失败');
      }
    },

    addNode() {
      const nextIndex = this.approvalNodes.length > 0
        ? Math.max(...this.approvalNodes.map(n => n.index)) + 1
        : 1;
      this.approvalNodes.push({
        index: nextIndex,
        nodeName: `审批节点${nextIndex}`,
        role: 'specificPerson',
        specificUsers: []
      });
    },

    removeNode(index) {
      this.approvalNodes.splice(index, 1);
      this.approvalNodes.forEach((node, i) => { node.index = i + 1; });
    },

    roleChange(index) {
      this.approvalNodes[index].specificUsers = [];
    },

    specificUsersChange(index) {
      const node = this.approvalNodes[index];
      const idSet = new Set((node.specificUsers || []).map(id => String(id)));
      const names = this.userList
        .filter(u => idSet.has(String(u.Id)))
        .map(u => u.TeacherName);
      node.nodeName = names.length ? `${names.join('、')}审批` : node.nodeName;
    },

    submitApprovalNodes() {
      const invalid = this.approvalNodes.find(n =>
        n.role === 'specificPerson' && (!n.specificUsers || !n.specificUsers.length)
      );
      if (invalid) {
        this.$message.error('存在指定人员节点未选择具体审批人');
        return;
      }
      const para = {
        processId: this.processId,
        processOfficerDetails: this.approvalNodes.map((node, idx) => ({
          index: idx + 1,
          nodeName: node.nodeName,
          role: node.role,
          specificUsers: (node.specificUsers || []).map(id => String(id)),
          days: 0
        }))
      };
      addProcessOfficer(para).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功');
          this.addApprovalNodeVisible = false;
        } else {
          this.$message.error(res.data.msg || '保存失败');
        }
      });
    },

    async showCopyToUsers(row) {
      this.currentProcessId = row.Id;
      this.copyToUsersVisible = true;
      try {
        await this.loadScheduleAdmins(row.DepartmentId, row.GradeId);
        const res = await getProcessCc({ processId: row.Id });
        if (res.data && res.data.success && res.data.response) {
          const ids = this.parseSpecificUserIds(res.data.response.CcPersonIds);
          this.ensureUserOptions(ids, res.data.response.CcPersonNames);
          this.copyToForm.copyToUsers = ids.map(id => String(id));
        } else {
          this.copyToForm.copyToUsers = [];
        }
      } catch (e) {
        this.$message.error('加载抄送人员失败');
      }
    },

    saveCopyToUsers() {
      if (!this.copyToForm.copyToUsers || !this.copyToForm.copyToUsers.length) {
        this.$message.error('请至少选择一名抄送人员');
        return;
      }
      this.copyToLoading = true;
      const para = {
        processId: this.currentProcessId,
        ccPersonIds: this.copyToForm.copyToUsers.join('|'),
        ccPersonNames: this.copyToForm.copyToUsers
          .map(id => {
            const user = this.userList.find(u => String(u.Id) === String(id));
            return user ? user.TeacherName : '';
          })
          .filter(n => n).join('|')
      };
      saveProcessCc(para).then(res => {
        this.copyToLoading = false;
        if (res.data && res.data.success) {
          this.$message.success('保存成功');
          this.copyToUsersVisible = false;
        } else {
          this.$message.error((res.data && res.data.msg) || '保存失败');
        }
      }).catch(() => { this.copyToLoading = false; });
    }
  },

  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>
